import { useLocation, useNavigate } from 'react-router-dom';

interface BottomNavProps {
  hidden?: boolean;
}

const tabs = [
  { label: 'Home', icon: '🏠', path: '/app' },
  { label: 'Stats', icon: '📊', path: '/stats' },
  { label: 'Progress', icon: '📖', path: '/progress' },
  { label: 'Profile', icon: '👤', path: '/profile' },
];

const BottomNav = ({ hidden = false }: BottomNavProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  if (hidden) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 flex pb-safe">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`flex-1 flex flex-col items-center justify-center py-3 gap-0.5 transition-colors ${
              isActive ? 'text-teal-600' : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            <span className="text-xl leading-none">{tab.icon}</span>
            <span className={`text-[10px] font-semibold ${isActive ? 'text-teal-600' : 'text-gray-400'}`}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
